import { useEffect, useMemo, type ReactNode } from 'react';
import { withDeviceManagementContainer } from '../../utils/withDeviceManagementContainer.util';
import { useSyncMerchantConfigurationModal } from '../../hooks/useSyncConfigurationMerchantModal.hook';
import { useDeviceManagementCapability } from '../../hooks';
import SyncIcon from '@mui/icons-material/Sync';
import { useTranslation } from 'react-i18next';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type {
  ExposedSyncConfigurationModalProps,
  SyncConfigurationModalState,
} from '../../model/syncConfigurationModal.model';

export function ExposedSyncConfigurationMerchantModalComponent({
  onStateChange,
  id: merchantId,
}: ExposedSyncConfigurationModalProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.MERCHANT, ALL_LNGS_NAMESPACES.COMMON]);

  const canMsSyncConfiguration = useDeviceManagementCapability('logicalDevice.msSyncConfiguration');

  const { handleOpenModal, modalComponent, isModalOpen, handleCloseModal } = useSyncMerchantConfigurationModal();

  const menuOption = useMemo<SyncConfigurationModalState['menuOption']>(() => {
    return canMsSyncConfiguration
      ? {
          icon: <SyncIcon />,
          label: t('button.syncConfig'),
          onClick: () => handleOpenModal(merchantId),
          dataTestId: 'btn-sync-configuration-merchant',
        }
      : undefined;
  }, [handleOpenModal, t, canMsSyncConfiguration, merchantId]);

  const state = useMemo<SyncConfigurationModalState>(
    () => ({
      menuOption,
      isMobileDialogOpen: isModalOpen,
      handleCloseMobileDialog: handleCloseModal,
    }),
    [isModalOpen, menuOption, handleCloseModal],
  );

  useEffect(() => {
    onStateChange(state);
  }, [state, onStateChange]);

  return modalComponent;
}

export const ExposedSyncConfigurationMerchantModal = withDeviceManagementContainer(
  ExposedSyncConfigurationMerchantModalComponent,
);
